import React from "react";
import { Link } from "react-router-dom";
import { Gift, ArrowRight } from "lucide-react";
import { useAuth } from "../context/AuthContext";

/**
 * SignupBonusPromoBanner — v3.99d.363
 *
 * Top-of-homepage promo banner that greets logged-OUT visitors with
 * the "$10 to join / $20 for referring a friend" pitch. Renders
 * nothing for authenticated users — the dashboard already has its
 * own ribbon + celebration for them.
 *
 * Position: absolute top of the home page, above the hero. Slim,
 * gold-accented, one-tap CTA → /register.
 */
export default function SignupBonusPromoBanner() {
  const { user } = useAuth();
  if (user) return null;

  return (
    <div
      className="relative overflow-hidden border-b"
      style={{ background: "linear-gradient(90deg, rgba(212,175,55,0.16) 0%, rgba(212,175,55,0.06) 50%, rgba(212,175,55,0.16) 100%)",
                borderColor: "var(--gold)" }}
      data-testid="signup-bonus-promo-banner">
      {/* Gold accent stripe */}
      <div className="absolute bottom-0 left-0 right-0 h-[2px]"
           style={{ background: "linear-gradient(90deg, transparent, var(--gold), transparent)" }}/>
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6 py-3 flex items-center gap-3 sm:gap-4 flex-wrap">
        <div className="flex-shrink-0 w-9 h-9 flex items-center justify-center"
             style={{ background: "var(--gold)",
                      color: "var(--bg)",
                      borderRadius: 2 }}>
          <Gift className="w-4 h-4"/>
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-[10px] font-mono uppercase tracking-[0.22em]"
               style={{ color: "var(--gold)" }}>
            Welcome bonus
          </div>
          <div className="text-sm sm:text-base font-semibold leading-tight"
               style={{ color: "var(--text)" }}>
            <span style={{ color: "var(--gold)" }}>$10 Forge Funds</span> when you join
            <span className="hidden sm:inline"> · <span style={{ color: "var(--gold)" }}>$20</span> per friend you refer</span>
          </div>
        </div>
        <Link
          to="/register"
          data-testid="signup-bonus-promo-cta"
          className="inline-flex items-center gap-1.5 px-3 sm:px-4 py-2 text-[10px] sm:text-[11px] font-mono uppercase tracking-[0.18em] transition hover:scale-[1.02] flex-shrink-0"
          style={{ background: "var(--gold)",
                    color: "var(--bg)",
                    borderRadius: 2 }}>
          Claim my $10
          <ArrowRight className="w-3 h-3 sm:w-3.5 sm:h-3.5"/>
        </Link>
      </div>
    </div>
  );
}
